import { Component, ComponentRef, Injector, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseComponentWithDialog } from "../../../base-admin-panel/base-component-with-dialog";
import { ObjectCreateViewModel } from "../../Models/ObjectViewModel";
import { ObjectsManagementDialogComponent } from "../../../objects-management-dialog/objects-management-dialog.component";
import { NotificationViewModel } from "../../../Notifications/Model/NotificationViewModel";
import { NotificationsService } from "../../../../../services/notifications.service";
import { EditNotificationComponent } from "../../../Notifications/edit-notification.component";
import { ObjectModel } from "../../../../../models/ObjectModel";
import { AccessRights } from 'app/services/users.service';

@Component({
  selector: 'object-events-part',
  templateUrl: './object-events-part.component.html',
  styleUrls: ['./object-events-part.component.css'],
  standalone: false
})
export class ObjectEventsPartComponent extends BaseComponentWithDialog implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;

  objectsListDialog: ComponentRef<any>;

  @Input()
  public Object: ObjectModel;

  private notificationsService: NotificationsService;
  private notifications: NotificationViewModel[] = [];
  public linkednotifications: NotificationViewModel[] = [];
  public canEditTrackers: boolean=false;

  constructor(protected injector: Injector) {
    super(injector);
    this.notificationsService = injector.get(NotificationsService);
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }


  ngOnInit(): void {
    super.ngOnInit();
    this.notificationsService.GetNotifications()
      .subscribe(notifications => {
        this.notifications = notifications;

        this.RefreshEvents();
      })
  }

  RefreshEvents() {
    this.linkednotifications = [];
    for (let i = 0; i < this.notifications.length; i++)
      for (let j = 0; j < this.Object.EventIds.length; j++)
        if (this.Object.EventIds[j] == this.notifications[i].Id)
          this.linkednotifications.push(this.notifications[i]);
  }

  public openAdd() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);

    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.notifications.forEach(notification => {
        if (this.Object.EventIds.indexOf(notification.Id) < 0) {
          notification.IsChecked = false;
          this.objectsListDialog.instance.objects.push(notification);
        }
      })
    });

    this.objectsListDialog.instance.onSubmit.subscribe(() => {
      this.objectsListDialog.instance.objects.forEach(notification => {
        if (notification && notification.IsChecked && this.Object.EventIds.indexOf(notification.Id) < 0)
          this.Object.EventIds.push(notification.Id);
        this.RefreshEvents();
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }

  public openEdit(event: NotificationViewModel) {
    this.prepareModal(EditNotificationComponent);
    this.componentRef.instance.open(event);
  }

  public deleteEvent(event: NotificationViewModel) {
    let idx = this.Object.EventIds.indexOf(event.Id);
    if (idx >= 0)
      this.Object.EventIds.splice(idx, 1);
    this.RefreshEvents();
  }

}
